"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IX_TITLES = exports.IX_STRUCTS = exports.SystemInstructionType = exports.TransferWithSeedInfo = exports.AssignWithSeedInfo = exports.AllocateWithSeedInfo = exports.AllocateInfo = exports.AuthorizeNonceInfo = exports.InitializeNonceInfo = exports.WithdrawNonceInfo = exports.AdvanceNonceInfo = exports.CreateAccountWithSeedInfo = exports.TransferInfo = exports.AssignInfo = exports.CreateAccountInfo = void 0;
const superstruct_1 = require("superstruct");
const pubkey_1 = require("../../validators/pubkey");
exports.CreateAccountInfo = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    newAccount: pubkey_1.PublicKeyFromString,
    lamports: (0, superstruct_1.number)(),
    space: (0, superstruct_1.number)(),
    owner: pubkey_1.PublicKeyFromString,
});
exports.AssignInfo = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    owner: pubkey_1.PublicKeyFromString,
});
exports.TransferInfo = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    lamports: (0, superstruct_1.number)(),
});
exports.CreateAccountWithSeedInfo = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    newAccount: pubkey_1.PublicKeyFromString,
    base: pubkey_1.PublicKeyFromString,
    seed: (0, superstruct_1.string)(),
    lamports: (0, superstruct_1.number)(),
    space: (0, superstruct_1.number)(),
    owner: pubkey_1.PublicKeyFromString,
});
exports.AdvanceNonceInfo = (0, superstruct_1.type)({
    nonceAccount: pubkey_1.PublicKeyFromString,
    nonceAuthority: pubkey_1.PublicKeyFromString,
});
exports.WithdrawNonceInfo = (0, superstruct_1.type)({
    nonceAccount: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    nonceAuthority: pubkey_1.PublicKeyFromString,
    lamports: (0, superstruct_1.number)(),
});
exports.InitializeNonceInfo = (0, superstruct_1.type)({
    nonceAccount: pubkey_1.PublicKeyFromString,
    nonceAuthority: pubkey_1.PublicKeyFromString,
});
exports.AuthorizeNonceInfo = (0, superstruct_1.type)({
    nonceAccount: pubkey_1.PublicKeyFromString,
    nonceAuthority: pubkey_1.PublicKeyFromString,
    newAuthorized: pubkey_1.PublicKeyFromString,
});
exports.AllocateInfo = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    space: (0, superstruct_1.number)(),
});
exports.AllocateWithSeedInfo = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    base: pubkey_1.PublicKeyFromString,
    seed: (0, superstruct_1.string)(),
    space: (0, superstruct_1.number)(),
    owner: pubkey_1.PublicKeyFromString,
});
exports.AssignWithSeedInfo = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    base: pubkey_1.PublicKeyFromString,
    seed: (0, superstruct_1.string)(),
    owner: pubkey_1.PublicKeyFromString,
});
exports.TransferWithSeedInfo = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    sourceBase: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    lamports: (0, superstruct_1.number)(),
    sourceSeed: (0, superstruct_1.string)(),
    sourceOwner: pubkey_1.PublicKeyFromString,
});
exports.SystemInstructionType = (0, superstruct_1.enums)([
    "createAccount",
    "createAccountWithSeed",
    "allocate",
    "allocateWithSeed",
    "assign",
    "assignWithSeed",
    "transfer",
    "advanceNonce",
    "withdrawNonce",
    "authorizeNonce",
    "initializeNonce",
    "transferWithSeed",
]);
exports.IX_STRUCTS = {
    createAccount: exports.CreateAccountInfo,
    createAccountWithSeed: exports.CreateAccountWithSeedInfo,
    allocate: exports.AllocateInfo,
    allocateWithSeed: exports.AllocateWithSeedInfo,
    assign: exports.AssignInfo,
    assignWithSeed: exports.AssignWithSeedInfo,
    transfer: exports.TransferInfo,
    advanceNonce: exports.AdvanceNonceInfo,
    withdrawNonce: exports.WithdrawNonceInfo,
    authorizeNonce: exports.AuthorizeNonceInfo,
    initializeNonce: exports.InitializeNonceInfo,
    transferWithSeed: exports.TransferWithSeedInfo,
};
exports.IX_TITLES = {
    createAccount: "Create Account",
    createAccountWithSeed: "Create Account With Seed",
    allocate: "Allocate",
    allocateWithSeed: "Allocate With Seed",
    assign: "Assign",
    assignWithSeed: "Assign With Seed",
    transfer: "Transfer",
    advanceNonce: "Advance Nonce",
    withdrawNonce: "Withdraw Nonce",
    authorizeNonce: "Authorize Nonce",
    initializeNonce: "Initialize Nonce",
    transferWithSeed: "Transfer With Seed",
};
//# sourceMappingURL=types.js.map